module.exports = __webpack_public_path__ + "media/images/emblems/DreiHoefe-blazon-7846ab9a1e46d7439d19b70f9a37d659.svg";